// src/components/InfoLateralSaida/InfoLateralSaida.tsx

import React, { useState, useContext, useEffect, useRef } from "react";
import "./InfoLateralSaida.scss";
import "bootstrap/dist/js/bootstrap.bundle.min";
import axios from "axios";
import { AdicionandoDados } from "../../context/AdicionandoDados";
import { Modal as BootstrapModal } from "bootstrap"; // Importa o Modal do Bootstrap
import Select from "react-select";

import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Accordion } from "react-bootstrap";
import ReactPaginate from "react-paginate";

type Beneficiario = {
  id: string;
  beneficiario: string;
  tipodespesa: string;
};

interface Empresa {
  id: number;
  nomeempresa?: string;
  idempresa?: string;
  nomecentrocusto?: string;
  nomeprojeto?: string;
  tipodespesaempresa?: string;
}

// Interface para Anexos
interface Anexo {
  isPosibleEdit: boolean | undefined;
  name: string;
  path?: string;
  file?: File;
  id?: any;
}

// Interface para Saída
interface Saida {
  id: number;
  tipoconta: string; // Antes: iLSpt2Form01
  tipodespesa: string; // Antes: iLSpt2Form02
  fontesaida: string; // Antes: iLSpt2Form03
  datasaida: string; // Antes: iLSpt2Form04
  valorsaida: string; // Antes: iLSpt2Form05
  descricaosaida?: string; // Antes: iLSpt2Form06
}

// Componente para opções personalizadas
export const CustomOption = (props: any) => {
  return (
    <option id={props.id} value={props.value}>
      {props.valorApresentado}
    </option>
  );
};

// Componente Principal InfoLateralSaida
const InfoLateralSaida = () => {
  const { estaAdicionandoDados, setEstaAdicionandoDados } =
    useContext(AdicionandoDados);

  // Variáveis de estado renomeadas para refletir os nomes das propriedades no interface Saida
  const [tipoconta, setTipoconta] = useState<string>(""); // Antes: iLSpt2Form01
  const [tipodespesa, setTipodespesa] = useState<string>(""); // Antes: iLSpt2Form02
  const [fontesaida, setFontesaida] = useState<string>(""); // Antes: iLSpt2Form03
  const [datasaida, setDatasaida] = useState<string>(""); // Antes: iLSpt2Form04
  const [valorsaida, setValorsaida] = useState<string>(""); // Antes: iLSpt2Form05
  const [descricaosaida, setDescricaosaida] = useState<string>(""); // Antes: iLSpt2Form06
  const [anexo, setAnexo] = useState<any>();

  const [saidas, setSaidas] = useState<Saida[]>([]);
  const [dataPesquisaGeral, setDataPesquisaGeral] = useState("");
  const [saidaSelecionada, setSaidaSelecionada] = useState<Saida | null>(null); // Estado para a saída selecionada
  const [dataAnexos, setDataAnexos] = useState<Anexo[]>([]); // Estado para anexos

  const [projetosSelecionadosCount, setProjetosSelecionadosCount] =
    useState<number>(0);

  const [listaAnexos, setListaAnexos] = useState<any[]>([]);

  const [dataEmpresa, setDataEmpresa] = useState(
    localStorage.getItem("dataEmpresa")
  );

  const modalRef = useRef<HTMLDivElement>(null);
  const bootstrapModalRef = useRef<BootstrapModal | null>(null);

  const [startEsdit, setStartEdit] = useState<Boolean>(false);

  const toastSave = () => {
    toast.success("Operação realizada com sucesso!", {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };

  useEffect(() => {
    // Inicializa o modal do Bootstrap
    if (modalRef.current) {
      bootstrapModalRef.current = new BootstrapModal(modalRef.current, {
        backdrop: "static",
      });
    }
    renderTabela(); // Carrega as saídas quando o componente for montado
  }, []);

  useEffect(() => {
    if (saidaSelecionada) {
      getSaidaById(saidaSelecionada.id);
    }
  }, [saidaSelecionada]);

  // Função para buscar saídas por data
  const getAllComponentByData = async (data: any) => {
    try {
      const responseAll = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getAllComponentsByDataSaidas/${data}`
      );
      setSaidas(responseAll.data);
      separadorLista(saidas);
      toast.success("Dados buscados com sucesso!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao buscar os dados.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  // Função para renderizar a tabela de saídas
  const renderTabela = async () => {
    try {
      const responseAll = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getallsaidas`
      );
      setSaidas(responseAll.data);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao buscar os dados.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  const saveDataById = async (id: number) => {
    try {
      await axios.put(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/puteditsaidas/${id}`,
        {
          empresaselecionada: empresaSelecionada,
          tipodespesa: tipoDespesaSelecionada,
          centrocusto: centroCustoByEmpresaSelecionada,
          projetos: projetosByEmpresaSelecionada,
          beneficiario: beneficiarioSelecionado,
          fontesaida: fontesaida,
          datasaida: datasaida,
          valorsaida: valorsaida,
          descricaosaida: descricaosaida,
        }
      );

      // Chame saveAnexoSaida se houver anexos
      if (dataAnexos.length > 0) {
        await saveAnexoSaida(id);
      }

      // Notificação de sucesso
      toastSave();

      renderTabela();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
          "Erro ao atualizar os dados. Por favor, tente novamente.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  // Função para salvar anexos relacionados à saída
  const saveAnexoSaida = async (saidaId: number) => {
    try {
      for (const anexo of dataAnexos) {
        if (anexo.file) {
          const formData = new FormData();
          formData.append("file", anexo.file);

          const dataAtual = Date.now();
          const fileName = dataAtual + "_" + encodeURIComponent(anexo.name);

          const uploadUrl = `https://financeiro.api.protmar.com.br/${dataEmpresa}/uploadfilesaidas/${fileName}/${saidaId}`;

          await axios.post(uploadUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          // Notificação de sucesso para cada upload
          toast.success(`Anexo ${anexo.name} enviado com sucesso!`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        }
      }

      // Limpe os anexos após o upload
      setDataAnexos([]);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao fazer upload do arquivo.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  //Função para salvar novos dados (adicionar)
  const saveData = async () => {
    try {
      const dataFormatada = new Date(datasaida).toISOString().slice(0, 10);
      const valorCalculado =
        projetosSelecionadosCount > 0
          ? (parseFloat(valorsaida) / projetosSelecionadosCount).toFixed(2)
          : parseFloat(valorsaida).toFixed(2);

      const response = await axios.post(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/postallsaidas`,
        {
          empresaselecionada: empresaSelecionada,
          tipodespesa: tipoDespesaSelecionada,
          centrocusto: centroCustoByEmpresaSelecionada,
          projetos:
            projetosByEmpresaSelecionada.length > 0
              ? projetosByEmpresaSelecionada
              : [],
          beneficiario: beneficiarioSelecionado,
          fontesaida: fontesaida,
          datasaida: dataFormatada,
          valorsaida: valorCalculado,
          descricaosaida: descricaosaida,
        }
      );

      const saidaId = response.data.id; // Obtenha o ID da nova saída

      // Chame saveAnexoSaida se houver anexos
      if (dataAnexos.length > 0) {
        await saveAnexoSaida(saidaId);

        dataAnexos.map((anexo) => {
          anexo.isPosibleEdit = false;
        })
      }

      // Notificação de sucesso

      setSaidaSelecionada(null);
      setTipoconta("");
      setTipodespesa("");
      setFontesaida("");
      setBeneficiarioSelecionado("");
      setDatasaida("");
      setCentroCustoByEmpresaSelecionada("");
      setValorsaida("");
      setDescricaosaida("");
      setDataAnexos([]);
      setEmpresaSelecionada("");
      setListaAnexos([]);

      renderTabela();
      toastSave();
    } catch (error: any) {
      if (error instanceof Error) {
        toast.error(
          `Erro ao salvar os dados: ${error.message}. Por favor, tente novamente.`,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      } else {
        toast.error(
          "Erro desconhecido ao salvar os dados. Por favor, verifique o console.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      }
    }
  };

  // Função para obter uma saída por ID
  const getSaidaById = async (id: number) => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getsaidasbyid/${id}`
      );

      setEmpresaSelecionada(response.data.empresaselecionada);
      setTipoDespesaSelecionada(response.data.tipodespesa);
      setCentroCustoByEmpresaSelecionada(response.data.centrocusto);
      setProjetosByEmpresaSelecionada(response.data.projetos);
      setBeneficiarioSelecionado(response.data.beneficiario);
      setFontesaida(response.data.fontesaida);
      setDatasaida(response.data.datasaida.slice(0, 10)); // Assumindo que a data está em formato ISO
      setValorsaida(response.data.valorsaida);
      setDescricaosaida(response.data.descricaosaida || "");

      const anexos = response.data.anexo || [];

      const formattedAnexos: Anexo[] = anexos.map((anexo: any) => {
        return {
          name: anexo.name,
          path: anexo.path,
        };
      });
      setDataAnexos(formattedAnexos);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar os dados por ID.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  // Função para deletar uma saída
  const deleteData = async (id: number) => {
    try {
      await axios.delete(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/deletesaidas/${id}`
      );
      renderTabela();
      toast.success("Saída deletada com sucesso!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      bootstrapModalRef.current?.hide(); // Fecha o modal após deletar
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
          "Erro ao deletar os dados. Por favor, tente novamente.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  // Estado para opções de despesas fixas
  const [optionsDespesasFixas, setOptionsDespesasFixas] = useState<any[]>([]);

  // Função para obter todas as despesas fixas
  const getAllDespesasFixas = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getdespesasfixas`
      );

      const options = response.data.map((e: any) => (
        <CustomOption
          key={e.id}
          valorApresentado={e.beneficiario}
          value={e.beneficiario}
          id={e.id}
          descricao={e.descricao}
        />
      ));

      setOptionsDespesasFixas(options);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar despesas fixas.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  useEffect(() => {
    getAllDespesasFixas();
  }, []);

  const handleEditarClick = (saida: any) => {
    setSaidaSelecionada(saida);
    setMostrarAnexos(false); // Reseta o estado de exibição de anexos
    bootstrapModalRef.current?.show(); // Exibe o modal sem anexos inicialmente
  };

  // Função para lidar com o clique no botão "Adicionar"
  const handleAdicionarClick = () => {
    setSaidaSelecionada(null);
    setTipoconta("");
    setTipodespesa("");
    setFontesaida("");
    setDatasaida("");
    setValorsaida("");
    setDescricaosaida("");
    setDataAnexos([]);
    saveData();
  };

  const downloadFile = (file: string, fileName: string) => {
    const blob = new Blob([file]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleDownload = (file: any, fileName = "download.pdf") => {
    if (file) {
      downloadFile(file, fileName);
    }
  };

  const openImages = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    name: string
  ) => {
    event.preventDefault();
    try {
      // Faz a requisição para buscar a URL pré-assinada passando o ID do anexo
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/get-signed-url/${name}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Adiciona o token JWT no cabeçalho
          },
        }
      );

      window.open(response.data.url);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao carregar a URL pré-assinada.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const [nomeTime, setNomeTime] = useState<any[]>([]);
  const [ILSpt2Form06, setILSpt2Form06] = useState<any>();

  const getTimesList = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/gettimes`
      );
      const teams = response.data;

      // Para cada time, busque seus projetos
      const teamsWithProjectsPromises = teams.map(async (team: any) => {
        const projetosResponse = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getprojetobynome/${team.nometime}`
        );
        return {
          ...team,
          projetos: projetosResponse.data,
        };
      });

      const teamsWithProjects = await Promise.all(teamsWithProjectsPromises);

      setNomeTime(teamsWithProjects);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao buscar times.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    getTimesList();
  }, []);

  const normalizeString = (str: string) =>
    str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove acentos
      .trim()
      .toLowerCase();

  const [mostrarAnexos, setMostrarAnexos] = useState<boolean>(false); // Adiciona estado para exibir anexos

  const handleExibirAnexosClick = async () => {
    if (!saidaSelecionada) {
      setMostrarAnexos(true);
      return;
    }

    const id = saidaSelecionada.id;

    try {
      // Faz a requisição para buscar os anexos
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getallimagessaidas/${id}`
      );

      const listaToAdd: Anexo[] = response.data.map((e: any) => ({
        name: e.name,
        path: e.url,
      }));

      // Atualiza o estado com os anexos e seta para exibição
      setDataAnexos(listaToAdd);
      setMostrarAnexos(true); // Garante que os anexos serão exibidos

      // Notificação de sucesso
      toast.success("Anexos carregados com sucesso!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao carregar anexos.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  const [empresasCadastradas, setEmpresasCadastradas] = useState<Empresa[]>([]);
  const [empresaSelecionada, setEmpresaSelecionada] = useState<string>("");
  const [empresaFonteSaida, setEmpresaFonteSaida] = useState("");

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getempresas/`
        );
        setEmpresasCadastradas(response.data);
      } catch (error: any) {
        toast.error(
          error.response?.data?.message ||
            "Erro ao buscar empresas cadastradas.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      }
    };

    fetchEmpresas();
  }, [dataEmpresa]);

  const [centroCustoByEmpresa, setCentroCustoByEmpresa] = useState<Empresa[]>(
    []
  );
  const [centroCustoByEmpresaSelecionada, setCentroCustoByEmpresaSelecionada] =
    useState("");

  const [projetosByEmpresa, setProjetosByEmpresa] = useState<Empresa[]>([]);
  const [projetosByEmpresaSelecionada, setProjetosByEmpresaSelecionada] =
    useState<string[]>([]);

  const getCentroCustoByEmpresa = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getcentrocustobyidempresa/${empresaSelecionada}`
      );
      setCentroCustoByEmpresa(response.data);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar centros de custo.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const getProjetosByEmpresa = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getprojetosbyidcc/${centroCustoByEmpresaSelecionada}`
      );
      setProjetosByEmpresa(response.data);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao buscar projetos.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    if (empresaSelecionada) {
      // Verifica se uma empresa foi realmente selecionada
      getCentroCustoByEmpresa();
    }
  }, [empresaSelecionada]);

  useEffect(() => {
    if (centroCustoByEmpresaSelecionada) {
      // Verifica se um centro de custo foi realmente selecionado
      getProjetosByEmpresa();
    }
  }, [centroCustoByEmpresaSelecionada]);

  const [idCentroCustoSelecionado, setIdCentroCustoSelecionado] = useState("");
  const [centroCustosCadastrados, setCentroCustosCadastrados] = useState<any[]>(
    []
  );

  useEffect(() => {
    const fetchCentroCustos = async () => {
      try {
        const response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getcentrocusto/`
        );
        setCentroCustosCadastrados(response.data);
      } catch (error: any) {
        toast.error(
          error.response?.data?.message ||
            "Erro ao buscar centros de custo cadastrados.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      }
    };

    fetchCentroCustos();
  }, [dataEmpresa]);

  const [visualizarAddProjeto, setVisualizarAddProjeto] = useState(false);
  const [nomeProjeto, setNomeProjeto] = useState("");

  const handleSaveProjeto = async () => {
    try {
      await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postprojetos`, {
        nomeprojeto: nomeProjeto,
        idcentrocusto: idCentroCustoSelecionado,
      });

      getProjetosByEmpresa();
      toastSave();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao cadastrar projeto.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const options2 = projetosByEmpresa
    .filter((e) => e.nomeprojeto !== undefined && e.nomeprojeto !== null)
    .map((e) => ({
      value: e.nomeprojeto as string,
      label: e.nomeprojeto as string,
    }));

  const options3 = projetosByEmpresaSelecionada.map((e) => ({
    value: e,
    label: e,
  }));

  const [beneficiarioSelecionado, setBeneficiarioSelecionado] = useState("");
  const handleSaveBeneficiario = async () => {
    try {
      await axios.post(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/postbeneficiarios`,
        {
          beneficiario: beneficiarioSelecionado,
        }
      );

      getAllBeneficiarios();
      toastSave();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao cadastrar beneficiário.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const [visualizarAddBeneficiario, setVisualizarAddBeneficiario] =
    useState(false);
  const [allBeneficiarios, setAllBeneficiarios] = useState<Beneficiario[]>([]);

  const getAllBeneficiarios = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getbeneficiarios`
      );

      setAllBeneficiarios(response.data);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar beneficiários.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  useEffect(() => {
    getAllBeneficiarios();
  }, [dataEmpresa]);

  const [visualizarAddFontesaida, setVisualizarAddFontesaida] = useState(false);

  const handleSaveFonteSaida = async () => {
    try {
      await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postfontesaida`, {
        fontesaida: fontesaida,
        tipodespesa: tipoDespesaSelecionada,
      });

      getAllFonteSaida();
      setFontesaida("");
      toastSave();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao cadastrar fonte de saída.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const [allFonteSaida, setAllFonteSaida] = useState<any[]>([]);

  const getAllFonteSaida = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getfontesaida/`
      );

      setAllFonteSaida(response.data);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar fontes de saída.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  useEffect(() => {
    getAllFonteSaida();
  }, [dataEmpresa]);

  const [tipoDespesaSelecionada, setTipoDespesaSelecionada] = useState("");
  const [
    tipoDespesaSelecionadaValueInput,
    setTipoDespesaSelecionadaValueInput,
  ] = useState("");

  // Função para lidar com a mudança de arquivos
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const filesArray: Anexo[] = Array.from(e.target.files).map((file) => ({
        name: file.name,
        file: file,
        isPosibleEdit: true
      }));
      setDataAnexos((prevAnexos) => [...prevAnexos, ...filesArray]);
    }
  };

  // Função para deletar um anexo
  const deleteDataAnexos = (anexoToDelete: Anexo) => {
    setDataAnexos((prevAnexos) =>
      prevAnexos.filter((anexo) => anexo !== anexoToDelete)
    );
    toast.info(`Anexo ${anexoToDelete.name} removido.`, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };

  const [searchbar, setSearchbar] = useState("");

  const handleSearch = async () => {
    try {
      let response;

      // Verificar se o campo de pesquisa está vazio após remover espaços
      if (searchbar.trim() === "") {
        // Se vazio, buscar todas as saídas
        response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getallsaidas`
        );
      } else {
        // Caso contrário, realizar a busca com o valor do campo
        response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/barrapesquisa/${searchbar}`
        );
      }

      // Atualizar o estado com os dados recebidos
      setSaidas(response.data);
    } catch (error) {
      console.error("Erro ao realizar a busca:", error);
    }
  };

  const [saidasFormatada, setSaidasFormatada] = useState<Saida[][]>([]);
  const separadorLista = (dados: Saida[]) => {
    const lista2: Saida[][] = [];
    let lista1: Saida[] = [];

    for (let i = 0; i < dados.length; i++) {
      lista1.push(dados[i]);

      if (lista1.length === 10 || i === dados.length - 1) {
        lista2.push(lista1);
        lista1 = [];
      }
    }

    setSaidasFormatada(lista2); // Atualiza a estrutura de páginas
  };

  useEffect(() => {
    separadorLista(saidas);
  }, [saidas]);

  const [paginaSelecionada, setPaginaSelecionada] = useState(0);

  const renderTabelaAddData = () => {
    return (
      <table className="table">
        <tr>
          <td style={{ width: "50%" }}>
            <label htmlFor="">Empresa</label>
            <select
              className="form-select"
              aria-label="Selecione a Empresa"
              style={{ marginRight: "10px" }}
              value={empresaSelecionada}
              onChange={(e) => {
                const selectedEmpresa = e.target.value;
                setEmpresaSelecionada(selectedEmpresa);

                // Encontra a empresa correspondente e define o tipo de despesa
                const empresa = empresasCadastradas.find(
                  (empresa) => empresa.nomeempresa === selectedEmpresa
                );
                setTipoDespesaSelecionada(empresa?.tipodespesaempresa || "");
              }}
            >
              <option value="">Selecione a Empresa</option>
              {empresasCadastradas.map((empresa) => (
                <option key={empresa.id} value={empresa.nomeempresa}>
                  {empresa.nomeempresa}
                </option>
              ))}
            </select>
          </td>

          <td style={{ width: "50%" }}>
            <label htmlFor="">Centro de Custo</label>
            <select
              className="form-select"
              aria-label="Selecione o Centro de Custo"
              style={{ marginRight: "10px" }}
              value={centroCustoByEmpresaSelecionada}
              onChange={(e) =>
                setCentroCustoByEmpresaSelecionada(e.target.value)
              }
            >
              <option value="">Selecione o Centro de Custo</option>
              {centroCustoByEmpresa.map((e) => (
                <option key={e.id} value={e.nomecentrocusto}>
                  {e.nomecentrocusto}
                </option>
              ))}
            </select>
          </td>
        </tr>

        <tr>
          <td>
            <label htmlFor="">Projetos</label>
            <div style={{ display: "flex" }}>
              <Select
                aria-label="Selecione o Projeto"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginRight: "10px",
                  }),
                }}
                isMulti
                id="styleeee"
                options={options2} // Use sempre as opções de projetos cadastrados
                value={projetosByEmpresaSelecionada.map((name) => ({
                  value: name,
                  label: name,
                }))} // Define o valor com base nos projetos selecionados
                placeholder="Selecione o Projeto"
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions
                    ? selectedOptions.map((option) => option.value)
                    : [];
                  setProjetosByEmpresaSelecionada(
                    selectedValues ? selectedValues : []
                  );
                  setProjetosSelecionadosCount(selectedValues.length); // Atualiza o contador com a quantidade selecionada
                }}
              />

              <button
                type="button"
                onClick={() => {
                  setVisualizarAddProjeto(!visualizarAddProjeto);
                }}
                className="btn btn-primary"
              >
                {visualizarAddProjeto ? "-" : "+"}
              </button>
            </div>

            {visualizarAddProjeto && (
              <div className="card" style={{ width: "96%", marginTop: "10px" }}>
                <div className="card-body" style={{ width: "100%" }}>
                  <h5 className="card-title">Adicionar Projeto</h5>
                  <label htmlFor="">Nome do Projeto</label>
                  <input
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setNomeProjeto(e.target.value);
                    }}
                    type="text"
                    className="form-control"
                  />

                  <br />

                  <div style={{ display: "flex" }}>
                    <select
                      className="form-select"
                      aria-label="Selecione o Centro de Custo"
                      style={{ marginRight: "10px" }}
                      value={idCentroCustoSelecionado}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                        setIdCentroCustoSelecionado(e.target.value)
                      }
                    >
                      <option value="">Selecione o Centro de Custo</option>
                      {centroCustosCadastrados.map((cc: any) => (
                        <option key={cc.id} value={cc.nomecentrocusto}>
                          {cc.nomecentrocusto}
                        </option>
                      ))}
                    </select>

                    <button
                      type="button"
                      onClick={handleSaveProjeto}
                      className="btn btn-primary"
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </td>

          <td>
            <label htmlFor="">Beneficiário</label>
            <div style={{ display: "flex" }}>
              <select
                className="form-select"
                aria-label="Selecione o Beneficiário"
                style={{ marginRight: "10px" }}
                value={beneficiarioSelecionado}
                onChange={(e) => setBeneficiarioSelecionado(e.target.value)}
              >
                <option value="">Selecione o Beneficiário</option>
                {allBeneficiarios.map((cc: Beneficiario) => (
                  <option key={cc.id} value={cc.beneficiario}>
                    {cc.beneficiario}
                  </option>
                ))}
              </select>

              <button
                type="button"
                onClick={() => {
                  setVisualizarAddBeneficiario(!visualizarAddBeneficiario);
                }}
                className="btn btn-primary"
              >
                {visualizarAddBeneficiario ? "-" : "+"}
              </button>
            </div>
            {visualizarAddBeneficiario && (
              <div className="card" style={{ width: "96%", marginTop: "10px" }}>
                <div className="card-body" style={{ width: "100%" }}>
                  <h5 className="card-title">Adicionar Beneficiário</h5>

                  <br />
                  <label htmlFor="">Nome do Beneficiário</label>

                  <div style={{ display: "flex" }}>
                    <input
                      style={{ marginRight: "10px" }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setBeneficiarioSelecionado(e.target.value);
                      }}
                      type="text"
                      className="form-control"
                    />

                    <button
                      type="button"
                      onClick={handleSaveBeneficiario}
                      className="btn btn-primary"
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </td>
        </tr>

        <tr>
          <td>
            <label htmlFor="">Fonte Saída</label>
            <div style={{ display: "flex" }}>
              <select
                className="form-select"
                aria-label="Selecione a Fonte de Saída"
                style={{ marginRight: "10px" }}
                value={fontesaida}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                  const selectedFonteSaida = e.target.value;
                  setFontesaida(selectedFonteSaida);

                  // Busca o item completo em `allFonteSaida` para obter `tipodespesa`
                  const fonteSaidaSelecionada = allFonteSaida.find(
                    (cc: any) => cc.fontesaida === selectedFonteSaida
                  );

                  // Define `tipodespesa` se o item foi encontrado
                  if (fonteSaidaSelecionada) {
                    setTipoDespesaSelecionada(
                      fonteSaidaSelecionada.tipodespesa
                    );
                  }
                }}
              >
                <option value="">Selecione a Fonte de Saída</option>
                {allFonteSaida.map((cc: any) => (
                  <option key={cc.id} value={cc.fontesaida}>
                    {cc.fontesaida}
                  </option>
                ))}
              </select>

              <input
                id="disabledTextInput"
                type="text"
                value={tipoDespesaSelecionada}
                className="form-control"
                disabled
                style={{ marginRight: "10px" }}
              />

              <button
                type="button"
                onClick={() => {
                  setVisualizarAddFontesaida(!visualizarAddFontesaida);
                }}
                className="btn btn-primary"
              >
                {visualizarAddFontesaida ? "-" : "+"}
              </button>
            </div>

            {visualizarAddFontesaida && (
              <div className="card" style={{ width: "96%", marginTop: "10px" }}>
                <div className="card-body" style={{ width: "100%" }}>
                  <h5 className="card-title">Adicionar Fonte de Saída</h5>

                  <br />
                  <label htmlFor="">Nome da Fonte de Saída</label>

                  <div style={{ display: "flex" }}>
                    <input
                      style={{ marginRight: "10px" }}
                      onChange={(e: any) => {
                        setFontesaida(e.target.value);
                      }}
                      type="text"
                      className="form-control"
                    />

                    <select
                      name=""
                      id=""
                      className="form-select"
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        setTipoDespesaSelecionada(e.target.value);
                      }}
                      style={{ marginRight: "10px" }}
                    >
                      <option value="" defaultChecked>
                        Selecione o Tipo de Despesa
                      </option>
                      <option value="Fixa">Fixa</option>
                      <option value="Variavel">Variável</option>
                    </select>

                    <button
                      type="button"
                      onClick={handleSaveFonteSaida}
                      className="btn btn-primary"
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </td>

          <td>
            <div className="mb-3">
              <label className="form-label" htmlFor="datasaida">
                Data
              </label>
              <input
                id="datasaida"
                type="date"
                className="form-control"
                value={datasaida}
                onChange={(e) => setDatasaida(e.target.value)}
              />
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <div className="mb-3">
              <label className="form-label" htmlFor="valorsaida">
                Valor
              </label>
              <input
                id="valorsaida"
                type="number"
                className="form-control"
                value={valorsaida}
                onChange={(e) => setValorsaida(e.target.value)}
                placeholder="Digite o valor da saída"
                min="0"
                step="0.01"
              />
            </div>
          </td>

          <td>
            <div className="mb-3">
              <label className="form-label" htmlFor="descricaosaida">
                Observação
              </label>
              <textarea
                id="descricaosaida"
                className="form-control"
                rows={3}
                value={descricaosaida}
                onChange={(e) => setDescricaosaida(e.target.value)}
                placeholder="Digite uma observação (opcional)"
              ></textarea>
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <div className="mb-3">
              <label className="form-label" htmlFor="anexos">
                Anexos
              </label>
              <input
                id="anexos"
                type="file"
                multiple
                onChange={handleFileChange} // Atualiza a lista de anexos com os novos arquivos
                className="form-control"
              />
            </div>

            {/* Botão para exibir anexos */}
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleExibirAnexosClick}
            >
              Exibir Anexos
            </button>

            

            {/* Exibição condicional dos anexos */}
            {dataAnexos.length > 0 && (
              <div className="mb-3" style={{ marginTop: "10px" }}>
                <label className="form-label">Anexos Selecionados</label>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Nome</th>
                      <th scope="col">Visualizar</th>
                      <th scope="col">Excluir</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataAnexos.map((anexo, index) => (
                      <tr key={index}>
                        <td>{anexo.name}</td>
                        <td>
                          {anexo.file ? (
                            <button
                              onClick={(event) => openImages(event, anexo.name)}
                              className="btn btn-primary btn-sm"
                              disabled={anexo.isPosibleEdit}
                            >
                              Visualizar
                            </button>
                          ) : (
                            <button
                              onClick={(event) => openImages(event, anexo.name)}
                              className="btn btn-primary btn-sm"
                              disabled={anexo.isPosibleEdit}
                            >
                              Visualizar
                            </button>
                          )}
                        </td>
                        <td>
                          <button
                            onClick={() => deleteDataAnexos(anexo)}
                            className="btn btn-danger btn-sm"
                          >
                            Excluir
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </td>
        </tr>
      </table>
    );
  };

  return (
    <main id="ILEPt2Main" style={{position: "relative"}}>
      {/* ToastContainer para exibir notificações */}
      <ToastContainer />
      <div id="ILEDMainContainerInputDate">
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="date"
            value={dataPesquisaGeral}
            onChange={(e) => setDataPesquisaGeral(e.target.value)}
          />
          <button
            onClick={() => getAllComponentByData(dataPesquisaGeral)}
            className="btn btn-primary me-2"
          >
            Buscar
          </button>
          <button onClick={renderTabela} className="btn btn-primary me-2">
            Todas as Datas
          </button>
          
        </div>
      </div>

      {renderTabelaAddData()}
      <button style={{marginLeft: "-93%"}} onClick={saveData} className="btn btn-primary">Salvar</button>

      <div
        className="input-group mb-3"
        style={{
          maxWidth: "400px",
          width: "100vw",
          marginTop: "15px",
          marginLeft: "63%",
        }}
      >
        <input
          onChange={(e) => setSearchbar(e.target.value)}
          style={{ margin: "0" }}
          type="text"
          className="form-control"
          placeholder="Digite sua pesquisa"
          aria-label="Recipient's username"
          aria-describedby="basic-addon2"
        />
        <span
          onClick={() => {
            handleSearch();
          }}
          style={{ margin: "0", cursor: "pointer" }}
          className="input-group-text"
          id="basic-addon2"
        >
          Buscar
        </span>
      </div>

      {/* Tabela de saídas */}
      <table className="table table-striped mt-3">
        <table
          style={{ width: "100%", position: "relative" }}
          className="table"
        >
          <thead>
            <td style={{ position: "absolute", top: "-15px" }}>Data</td>
            <td style={{ position: "absolute", top: "-15px", left: "33%" }}>
              Fonte de Saída
            </td>
            <td style={{ position: "absolute", top: "-15px", left: "64%" }}>
              Valor de Saída
            </td>
          </thead>
        </table>

        {saidasFormatada.length > 0 &&
        paginaSelecionada < saidasFormatada.length &&
        Array.isArray(saidasFormatada[paginaSelecionada]) ? (
          saidasFormatada[paginaSelecionada].map((saida) => (
            <Accordion
              flush
              style={{ padding: "0" }}
              key={saida.id}
              onClick={() => {
                setSaidaSelecionada(saida);
              }}
            >
              <Accordion.Item eventKey="0" style={{ padding: "0" }}>
                <Accordion.Header style={{ padding: "0" }}>
                  <table
                    className="table table-bordered"
                    style={{ marginBottom: "0", marginRight: "20px" }}
                  >
                    <tbody>
                      <tr>
                        <td style={{ width: "33%" }}>
                          {new Date(saida.datasaida).toLocaleDateString(
                            "pt-BR"
                          )}
                        </td>
                        <td style={{ width: "33%" }}>{saida.fontesaida}</td>
                        <td style={{ width: "33%" }}>
                          R${" "}
                          {saida.valorsaida
                            ? parseFloat(saida.valorsaida).toLocaleString(
                                "pt-BR",
                                { style: "currency", currency: "BRL" }
                              )
                            : "0,00"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Accordion.Header>
                <Accordion.Body
                  style={{ padding: "10", boxShadow: "0 0 10px 1px #d9d9d9" }}
                >
                  {renderTabelaAddData()}
                  <button style={{ marginLeft:"10px" }} onClick={() => {
                    saveDataById(saida.id);
                  }} className="btn btn-primary">
                    Atualizar
                  </button>

                  <button style={{ marginLeft:"10px" }} onClick={() => {
                    deleteData(saida.id);
                  }} className="btn btn-danger">
                    Excluir
                  </button>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))
        ) : (
          <tr>
            <td colSpan={3} className="text-center">
              Nenhuma saída encontrada
            </td>
          </tr>
        )}
      </table>

      <nav aria-label="Page navigation example">
        <ul className="pagination">
          <li
            className={`page-item ${paginaSelecionada === 0 ? "disabled" : ""}`}
          >
            <a
              className="page-link"
              href="#"
              onClick={() =>
                paginaSelecionada > 0 &&
                setPaginaSelecionada(paginaSelecionada - 1)
              }
              aria-label="Previous"
            >
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          {paginaSelecionada - 1 >= 0 && (
            <li className="page-item">
              <a
                className="page-link"
                href="#"
                onClick={() => setPaginaSelecionada(paginaSelecionada - 1)}
              >
                {paginaSelecionada}
              </a>
            </li>
          )}
          <li className="page-item active">
            <span className="page-link">{paginaSelecionada + 1}</span>
          </li>
          {paginaSelecionada + 1 < saidasFormatada.length && (
            <li className="page-item">
              <a
                className="page-link"
                href="#"
                onClick={() => setPaginaSelecionada(paginaSelecionada + 1)}
              >
                {paginaSelecionada + 2}
              </a>
            </li>
          )}
          <li
            className={`page-item ${
              paginaSelecionada >= saidasFormatada.length - 1 ? "disabled" : ""
            }`}
          >
            <a
              className="page-link"
              href="#"
              onClick={() =>
                paginaSelecionada < saidasFormatada.length - 1 &&
                setPaginaSelecionada(paginaSelecionada + 1)
              }
              aria-label="Next"
            >
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </main>
  );
};

// Função para deletar um anexo do estado
const deleteDataAnexos = (
  anexoToDelete: Anexo,
  setDataAnexos: React.Dispatch<React.SetStateAction<Anexo[]>>
) => {
  setDataAnexos((prevAnexos) =>
    prevAnexos.filter((anexo) => anexo !== anexoToDelete)
  );
  toast.info(`Anexo ${anexoToDelete.name} removido.`, {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
  });
};

export { InfoLateralSaida };
